<template>
	<div class="page">
		<img :src="headImg" v-if="headImg" class="bg" alt="" />
		<div class="w1200">
			<div class="data">
				<div v-for="(value, key) in datalist" :class="{ data_active: activeTab == value }"
					@click="activateTab(value)" class="data_li" :key="key">
					{{ lan=="en"?value.replace("月",".").replace("日",""):value }}
				</div>
			</div>
			<div class="tip">选择您要报名的会议，然后点击页面底部“下一步”继续报名</div>
			<div class="meet_con">
				<div class="meet_left">
					<div v-for="(item, index) in list" :class="{ meet_active: btnTab == item.MgName }" class="meet_btn"
						@click="bindMeet(item)" :key="index">
						{{ lan=='en'?item.MgEName:item.MgName }}
					</div>
				</div>
				<div class="meet_right">
					<div class="scroll-H" scroll-y="true">
						<div v-for="(item, index) in list_con" @click="bindDetail(item)" class="meet_li" :key="index">
							<!-- 左上角角标 -->
							<div class="meet_logo_wrap" v-if="item.MtsCornerLogo || item.MtsCornerLogoTip">
								<span class="meet_logo_tip" v-if="item.MtsCornerLogoTip">{{ item.MtsCornerLogoTip }}</span>
								<img v-if="item.MtsCornerLogo" :src="item.MtsCornerLogo" class="meet_logo" alt="" />
							</div>
							<div class="meet_start">
								<div class="meet_img">
									{{lan=='en'?item.MtsETitle:item.MtsTitle }}
								</div>
								<div class="tit">
									<div class="name">
										{{lan=='en'?item.MtsETitle:item.MtsTitle }}
									</div>
									<div class="date">
										{{lan=='en'?'Time':'时间'}} :
										{{ item.MtsStartTime }}
									</div>
									<div class="address">
										{{lan=='en'?'Location':'地点'}}
										:{{lan=='en'?item.MtsEArea :item.MtsArea }}
									</div>
									<div class="priceRemark" v-if="item.MtsPriceRemark">
										{{ item.MtsPriceRemark }}
									</div>
								</div>
							</div>
							<div class="meetBtn">
								<div class="meet_btn" v-if="!item.select" @click.stop="bindId(item.MtsID)">
									{{lan=='en'?'Sign up':'会议报名'}}
								</div>
								<div class="meet_btned" v-if="item.select" @click.stop="bindCloseId(item.MtsID)">
									{{lan=='en'?'Registered':'已报名'}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- btn -->
			<div class="next" @click="bindNext"> {{lan=='en'?'Next':'下一步'}}</div>
			<!-- 嘉宾 -->
			<div class="vip" v-if="vipList.length > 0">
				<div class="title">{{lan=='en'?'Important guests':'重磅嘉宾'}}</div>
				<div class="vip_con">
					<div v-for="(item, index) in vipList" class="vip_li" :key="index">
						<el-image :src="item.VgSrc" v-if="item.VgSrc" class="img" fit="cover"></el-image>
						<div class="name">
							{{lan=='en'?item.VgEName:item.VgName }}
						</div>
						<div class="rank">
							{{lan=='en'?item.VgERank:item.VgRank }}
						</div>
						<div class="company">
							{{lan=='en'?item.VgERank:item.VgECompany }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		isMobileDevice
	} from "@/utils/deviceCheck";
	export default {
		name: "Details",
		data() {
			return {
				exhid: "",
				ExtID: "",
				limit: 4,
				headImg: "",
				activeTab: "",
				btnTab: "全部",
				page: 1,
				key: "",
				href: "",
				total: 0,
				datalist: [],
				proList: [],
				vipList: [],
				list: [],
				MgID: "",
				title: "",
				headerImg: "",
				regUrl: "",
				lan: "", // lan=en 的参数来显示英文
				isRequire: "",
				jumpUrl: "",
				dataValueList: {},
				list_con: [],
			};
		},
		computed: {
			idList() {
				return this.$store.state.idList;
			},
			flag() {
				return this.$store.state.flag;
			},
		},
		created() {
			console.log("调用获取id的方法", this.$route.query, !this.flag);
			if (this.$route.query) {
				this.exhid = this.$route.query.exhid;
				this.jumpUrl = this.$route.query.href;
				this.lan = this.$route.query.lan;
				this.isRequire = this.$route.query.isRequire;
				if (this.$route.query.MtsID && !this.flag) {
					let mtsList = this.$route.query.MtsID.split(",");
					mtsList.forEach((item) => {
						this.$store.commit("addToIdList", item);
					});
				}

				if (isMobileDevice()) {
					window.location.href =
						`https://hkh5.eainfor.com/#/pages/exhibition/index?exhid=${this.$route.query.exhid}&href=${this.$route.query.href}&MtsID=${this.$route.query.MtsID}&isRequire=${this.$route.query.isRequire}`;
				}
				setTimeout(() => {
					this.getMetting();
					this.getMettingDate();
					this.getVip();
					this.getImg();
				}, 0);
			}
		},
		mounted() {},
		methods: {
			getValueByKey(obj, key) {
				const {
					[key]: value
				} = obj;
				return value;
			},
			activateTab(tab) {
				let that = this;
				this.activeTab = tab;
				that.list_con = this.getValueByKey(this.dataValueList, tab);
				that.list_con.forEach((item) => {
					item.select = that.idList.includes(item.MtsID);
				});
				console.log("tab", tab);
			},
			bindMeet(item) {
				console.log("item", item);
				this.btnTab = this.lan == 'en' ? item.MgEName : item.MgName;
				if (item.MgID) {
					this.getMettingDate(item.MgID);
				} else {
					this.getMettingDate();
				}
			},
			//点击详情
			bindDetail(item) {
				let that = this;
				console.log("点击详情", item);
				this.$router.push({
					path: `/ExhibitionDetail?exhid=${that.exhid}&MtID=${item.MtsID}&lan=${this.lan}`,
				});
			},
			bindNext() {
				let that = this;
				console.log("bindNext", that.idList);
				if (that.isRequire) {
					if (that.idList.length > 0) {
						let id = that.idList.join(",");
						let url = that.jumpUrl.replace("{#MtsID#}", id);
						console.log(123, url);
						window.location.href = url;
					} else {
						if (that.lan == 'en') {
							this.$message.error("Please select a meeting to register");
						} else {
							this.$message.error("请选择要报名的会议");
						}


					}
				} else {
					let id = that.idList.join(",");
					let url = that.jumpUrl.replace("{#MtsID#}", id);
					console.log(123, url);
					window.location.href = url;
				}
			},
			bindId(id) {
				console.log(id);
				let that = this;
				that.list_con.forEach((item) => {
					if (item.MtsID == id) {
						item.select = true;
					}
				});
				this.$forceUpdate();
				this.$store.commit("addToIdList", id);
				console.log("idlist", that.idList);
			},
			bindCloseId(id) {
				console.log(id);
				let that = this;
				that.list_con.forEach((item) => {
					if (item.MtsID == id) {
						item.select = false;
					}
				});
				this.$forceUpdate();
				this.$store.commit("reduceToIdList", id);
				console.log("idlist", that.idList);
			},

			getMetting() {
				let that = this;
				let url = `https://api.eainfor.com/Exh/mettingGroups/${that.exhid}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						let _data = res.data.data;
						if (that.lan == 'en') {
							_data.unshift({
								MgName: "all",
							});
						} else {
							_data.unshift({
								MgName: "全部",
							});
						}


						that.list = _data;
						console.log("会议分组列表res", _data);
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			getImg() {
				let that = this;
				let url = `https://api.eainfor.com/Exh/settings/${that.exhid}?type=1`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						console.log("获取图片", res);
						if (that.lan == "en") {
							that.headImg = res.data.data.pc_en_banner;
						} else {
							that.headImg = res.data.data.pc_banner;
						}

						document.title = res.data.data.title ? res.data.data.title : "";
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			getVip() {
				let that = this;
				let url = `https://api.eainfor.com/Exh/vipGuests/${that.exhid}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						let _data = res.data.data;
						that.vipList = _data;
						console.log("嘉宾列表res", _data);
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			//点击跳转展品详情
			bindProductDetails(item) {
				let that = this;
				this.$router.push({
					path: `/productDetail?exhid=${that.exhid}&EpID=${item.EpID}`,
				});
			},
			getMettingDate(MgID) {
				let that = this;
				let Mgided = MgID ? MgID : that.MgID;
				let url = `https://api.eainfor.com/Exh/mettings/${that.exhid}?MgID=${Mgided}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						let _data = res.data.data;
						console.log("获取列表", _data);
						that.datalist = Object.keys(_data);
						that.dataValueList = _data;
						that.activeTab = that.activeTab ? that.activeTab : Object.keys(_data)[0];
						that.list_con = that.activeTab ?
							this.getValueByKey(_data, that.activeTab) :
							Object.values(_data)[0];

						// that.list_con.forEach((item, index) => {
						// 	item.select = false;
						// });
						console.log("获取列表2", that.list_con);
						that.list_con.forEach((item) => {
							item.select = that.idList.includes(item.MtsID);
						});
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
		},
	};
</script>

<style lang="less" scoped>
	.page {
		background: #f6f6f6;
		position: absolute;
		width: 100%;
		min-height: 100%;
	}

	.data {
		height: 2px;
		border-bottom: 2px solid #242ea3;
		margin-top: 0px;
		height: 80px;
		display: flex;

		.data_li {
			width: 33%;
			font-weight: 600;
			font-size: 20px;
			height: 80px;
			text-align: center;
			color: #333333;
			line-height: 80px;
			cursor: pointer;
		}

		.data_active {
			position: relative;
			color: #4e15ff;
		}

		.data_active::before {
			content: "";
			position: absolute;
			width: 127px;
			height: 10px;
			background: linear-gradient(90deg, #382ddf, #c92de7);
			border-radius: 5px;
			bottom: -5px;
			left: calc(50% - 63px);
		}
	}

	.meet_con {
		display: flex;
		margin-top: 20px;
		background: #393d6e;
		border-radius: 20px;
		height: 615px;

		.meet_left {
			width: 124px;
			margin-top: 50px;
			border-right: 1px solid#787EC9;

			.meet_btn {
				width: 124px;
				height: 86px;
				font-weight: 400;
				cursor: pointer;
				font-size: 18px;
				color: #ffffff;
				text-align: center;
				line-height: 86px;
			}

			.meet_active {
				background: #4e15ff;
			}
		}

		.meet_right {
			width: 100%;
			height: 100%;
			background: #393d6e;
			border-radius: 14rpx;

			.scroll-H {
				height: calc(100% - 60px);
				padding: 30px 0;
				overflow: hidden;
				overflow-y: scroll;
			}

			.meet_li {
				width: 956px;
				height: 170px;
				background: #1b1c30;
				border-radius: 20px;
				display: flex;
				margin: 0 auto;
				margin-top: 18px;
				align-items: center;
				cursor: pointer;
				justify-content: space-between;
				position: relative;
			}

			.meet_logo_wrap {
				position: absolute;
				top: -15px;
				left: -10px;
				z-index: 2;
				pointer-events: none;
				display: flex;
				align-items: center;
			}

			.meet_logo_tip {
				background: #DD0C80;
				color: #FFFFFF;
				font-size: 14px;
				font-weight: 500;
				padding: 3px 10px;
				width:150px;
				text-align: center;
				border-radius: 20px 0 0 0;
				white-space: nowrap;
				line-height: 30px;
				margin-left: 10px;
			}

			.meet_logo {
				width: 60px;
				height: 60px;
				object-fit: contain;
				margin-left: -10px;
			}

			.meet_start {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin-left: 26px;

				.meet_img {
					width: 184px;
					height: 130px;
					border-radius: 15px;
					background: url("https://osshb.eainfor.com/Dis/MAppResource/ex_bg.png") no-repeat;
					background-size: 100% 100%;
					font-weight: 500;
					font-size: 16px;
					color: #ffffff;
					line-height: 28px;
					text-align: center;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.tit {
					margin-left: 30px;

					.name {
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						font-weight: 400;
						font-size: 18px;
						color: #ffffff;
						line-height: 25px;
						width: 488px;
					}

					.date {
						font-weight: 400;
						font-size: 13px;
						color: #ffffff;
						line-height: 46px;
					}

					.address {
						font-weight: 400;
						font-size: 13px;
						color: #ffffff;
						line-height: 46px;
					}

					.priceRemark {
						margin-top: 4px;
						font-weight: 500;
						font-size: 14px;
						color: #DD0C80;
						line-height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 488px;
					}
				}
			}

			.meetBtn {
				margin-right: 22px;

				.meet_btn {
					width: 115px;
					height: 44px;
					border-radius: 8px;
					border: 1px solid #ffffff;
					text-align: center;
					flex-shrink: 0;
					font-size: 13px;
					font-weight: 400;
					color: #ffffff;
					line-height: 44px;
					cursor: pointer;
					// flex: 0 0 150rpx;
				}

				.meet_btned {
					width: 115px;
					height: 44px;
					border-radius: 8px;
					border: 1px solid #909090;
					text-align: center;
					flex-shrink: 0;
					font-size: 13px;
					font-weight: 400;
					color: #909090;
					line-height: 44px;
				}

				.meet_btn3 {
					margin-top: 18rpx;
				}
			}
		}
	}

	.next {
		width: 357px;
		height: 44px;
		background: #4e15ff;
		border-radius: 6px;
		font-weight: 500;
		font-size: 16px;
		color: #fffefe;
		line-height: 44px;
		margin: 0 auto;
		text-align: center;
		margin-top: 32px;
		margin-bottom: 104px;
		cursor: pointer;
	}

	.vip {
		margin-top: 30px;
		margin-bottom: 50px;

		.title {
			font-weight: 500;
			font-size: 30px;
			color: #333333;
			line-height: 23px;
			text-align: center;
			margin-bottom: 20px;
		}

		.vip_con {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;

			.vip_li {
				width: 33%;
				text-align: center;
				margin-top: 39px;

				.img {
					width: 162px;
					height: 162px;
					border-radius: 50%;
				}

				.name {
					font-size: 16px;
					font-weight: 600;
					color: #333333;
					line-height: 23px;
					padding-top: 19px;
				}

				.rank {
					font-size: 12px;
					font-weight: 400;
					color: #666666;
					padding-top: 10px;
				}

				.company {
					font-size: 12px;
					font-weight: 400;
					color: #666666;
					padding-top: 7px;
				}
			}
		}
	}

	.bg {
		display: block;
		width: 100%;
	}
	.tip{
		color:red;
		margin-top:10px;
		font-weight: bold;
		font-size: 18px;
	}
</style>